import React from 'react';
import { Card, Col, Row, Space, Typography } from 'antd';
import {
  EyeOutlined,
  ShoppingCartOutlined,
  ClockCircleOutlined,
  ShoppingOutlined,
  FundOutlined,
} from '@ant-design/icons';
import moment from 'moment';
import { formatWholeNumberNaN } from '../../../../../core/utils/campaigns';
import { dateFormat } from '../../../Tasks/configs/designTokens';
import '../../styles/index.scss';

const { Text } = Typography;

const colorPicker = (date, value) => {
  if (!date) return 'default';
  if (date && value < 1) return 'error';
  return 'success';
};

const TagMetricCards = ({ generatedTag, type }) => {
  const { pageViews, transactions, sessions, impressions, basketItems, date } =
    generatedTag;
  const hasBasketItems = basketItems > 0;

  const metricCards = () => {
    if (type === 'measurement') {
      return (
        <>
          <Col xs={24} sm={12} md={12} lg={6}>
            <Card
              size="small"
              className={`tags-metrics__card tags-metrics__card--${colorPicker(date, pageViews)}`}
            >
              <Space direction="vertical" size={4} className="tags-metrics__space">
                <Text type="secondary" className="tags-metrics__label">
                  <EyeOutlined className="tags-metrics__label-icon" />
                  <span className="tags-metrics__label-text">Page Views</span>
                </Text>
                <Text className="tags-metrics__value">
                  {formatWholeNumberNaN(pageViews)}
                </Text>
                <Text type="secondary" className="tags-metrics__date">
                  {date ? moment(date).format(dateFormat.short) : 'No Signal'}
                </Text>
              </Space>
            </Card>
          </Col>
          <Col xs={24} sm={12} md={12} lg={6}>
            <Card
              size="small"
              className={`tags-metrics__card tags-metrics__card--${colorPicker(date, transactions)}`}
            >
              <Space direction="vertical" size={4} className="tags-metrics__space">
                <Text type="secondary" className="tags-metrics__label">
                  <ShoppingCartOutlined className="tags-metrics__label-icon" />
                  <span className="tags-metrics__label-text">Transactions</span>
                </Text>
                <Text className="tags-metrics__value">
                  {formatWholeNumberNaN(transactions)}
                </Text>
                <Text type="secondary" className="tags-metrics__date">
                  {date ? moment(date).format(dateFormat.short) : 'No Signal'}
                </Text>
              </Space>
            </Card>
          </Col>
          <Col xs={24} sm={12} md={12} lg={6}>
            <Card
              size="small"
              className={`tags-metrics__card tags-metrics__card--${colorPicker(date, sessions)}`}
            >
              <Space direction="vertical" size={4} className="tags-metrics__space">
                <Text type="secondary" className="tags-metrics__label">
                  <ClockCircleOutlined className="tags-metrics__label-icon" />
                  <span className="tags-metrics__label-text">Sessions</span>
                </Text>
                <Text className="tags-metrics__value">
                  {formatWholeNumberNaN(sessions)}
                </Text>
                <Text type="secondary" className="tags-metrics__date">
                  {date ? moment(date).format(dateFormat.short) : 'No Signal'}
                </Text>
              </Space>
            </Card>
          </Col>
          {hasBasketItems && (
            <Col xs={24} sm={12} md={12} lg={6}>
              <Card
                size="small"
                className={`tags-metrics__card tags-metrics__card--${colorPicker(date, basketItems)}`}
              >
                <Space direction="vertical" size={4} className="tags-metrics__space">
                  <Text type="secondary" className="tags-metrics__label">
                    <ShoppingOutlined className="tags-metrics__label-icon" />
                    <span className="tags-metrics__label-text">Basket Items</span>
                  </Text>
                  <Text className="tags-metrics__value">
                    {formatWholeNumberNaN(basketItems)}
                  </Text>
                  <Text type="secondary" className="tags-metrics__date">
                    {date ? moment(date).format(dateFormat.short) : 'No Signal'}
                  </Text>
                </Space>
              </Card>
            </Col>
          )}
        </>
      );
    } else if (type === 'publisher') {
      return (
        <Col xs={24} sm={12} md={8} lg={6}>
          <Card
            size="small"
            className={`tags-metrics__card tags-metrics__card--${colorPicker(date, pageViews)}`}
          >
            <Space direction="vertical" size={4} className="tags-metrics__space">
              <Text type="secondary" className="tags-metrics__label">
                <EyeOutlined className="tags-metrics__label-icon" />
                <span className="tags-metrics__label-text">Page Views</span>
              </Text>
              <Text className="tags-metrics__value">
                {formatWholeNumberNaN(pageViews)}
              </Text>
              <Text type="secondary" className="tags-metrics__date">
                {date ? moment(date).format(dateFormat.short) : 'No Signal'}
              </Text>
            </Space>
          </Card>
        </Col>
      );
    } else if (type === 'impression') {
      return (
        <Col xs={24} sm={12} md={8} lg={6}>
          <Card
            size="small"
            className={`tags-metrics__card tags-metrics__card--${colorPicker(date, impressions)}`}
          >
            <Space direction="vertical" size={4} className="tags-metrics__space">
              <Text type="secondary" className="tags-metrics__label">
                <FundOutlined className="tags-metrics__label-icon" />
                <span className="tags-metrics__label-text">Impressions</span>
              </Text>
              <Text className="tags-metrics__value">
                {impressions}
              </Text>
              <Text type="secondary" className="tags-metrics__date">
                {date ? moment(date).format(dateFormat.short) : 'No Signal'}
              </Text>
            </Space>
          </Card>
        </Col>
      );
    }
  };

  return (
    <>
      <Text type="secondary" className="tags-generated__delay-notice">
        Results shown below may be delayed up to 1 hour
      </Text>
      <Row gutter={[16, 16]} className="tags-generated__results-row">
        {metricCards()}
      </Row>
    </>
  );
};

export default TagMetricCards;
